import * as React from 'react';

export default (props) => {
  let strokeColor;

  if (props.color) {
    strokeColor = props.color;
  } else {
    switch (props.state) {
      case 'hover':
        strokeColor = '#0A132B';
        break;
      case 'static':
        strokeColor = '#6C7280';
        break;
      case 'active':
        strokeColor = '#0067F4';
        break;
      default:
        strokeColor = '#B5BFD2';
    }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      fill="none"
    >
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6.5 9h12M6.5 15h12M9.5 18V6M15.5 18V6"
      />
    </svg>
  );
};
